module.exports = __webpack_public_path__ + "img/download-logo.fc67fd92.png";